const state = {
    // 当前桌面
    componentConfig: {}

}
const mutations = {
    SET_COMPONENT_CONIFG: (state, config) => {
        state.componentConfig = config;
    },
}
export default {
    state,
    mutations
}
